<template>
  <!-- Upload Section -->
  <div class="card mb-3">
    <div class="card-body p-3">
      <h6 class="card-title mb-3">Adicionar Arquivo</h6>
      <div class="col-md-6">
        <form @submit.prevent="uploadFile" class="row g-2 align-items-end">
          <div class="col-md-5">
            <label for="fileInput" class="form-label small mb-1">Arquivo</label>
            <input type="file"
                   class="form-control form-control-sm"
                   id="fileInput"
                   ref="fileInput"
                   @change="onFileSelect"
                   accept="image/*,application/pdf,.doc,.docx,.txt"
                   required>
          </div>
          <div class="col-md-4">
            <label for="fileName" class="form-label small mb-1">Nome do arquivo</label>
            <input type="text"
                   class="form-control form-control-sm"
                   id="fileName"
                   v-model="uploadForm.fileName"
                   placeholder="Ex: Exame de sangue"
                   required>
          </div>
          <div class="col-md-3">
            <button type="submit"
                    class="btn btn-primary btn-sm w-100"
                    :disabled="uploading">
              <span v-if="uploading" class="spinner-border spinner-border-sm me-1"></span>
              {{ uploading ? 'Enviando...' : 'Enviar' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <hr>
  <!-- Files Table -->
  <div class="table-responsive">
    <table class="table table-hover table-bordered table-row-dashed">
      <thead>
      <tr class="text-center fw-bolder">
        <th scope="col">#</th>
        <th scope="col">Arquivo</th>
        <th scope="col">Usuário</th>
        <th scope="col">Enviado em</th>
        <th scope="col">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="files.length < 1">
        <td colspan="12" class="text-center">
          Nenhum arquivo encontrado.
        </td>
      </tr>
      </tbody>
      <tbody :key="fileKey(file)" v-for="(file, index) in files" class="text-center">
      <tr>
        <td>{{ index + 1 }}</td>
        <td class="text-start">{{ file.file_name ?? file.name ?? '-' }}</td>
        <td>{{ file.user_name ?? file.created_by_name ?? '-' }}</td>
        <td>{{ formatDate(file.created_at ?? file.sent_at ?? file.uploaded_at) }}</td>
        <td>
          <button type="button"
                  class="btn btn-sm btn-icon btn-light btn-active-light-primary me-1 border border-gray-400"
                  title="Visualizar"
                  @click="downloadFile(file)">
            <i class="bi bi-eye"></i>
          </button>
          <button type="button"
                  class="btn btn-sm btn-icon btn-light btn-active-light-danger border border-gray-400"
                  title="Apagar"
                  @click="deleteFile(file)">
            <i class="bi bi-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";

export default {
  name: "ScheduleFilesTable",
  props: ['scheduleId', 'uniqueKey'],
  data() {
    return {
      files: [],
      uploading: false,
      uploadForm: {
        fileName: '',
        file: null
      }
    }
  },
  watch: {
    uniqueKey() {
      this.getScheduleFiles();
    },
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  methods: {
    date: moment,
    formatDate(value) {
      return value ? this.date(value).format('DD/MM/YYYY HH:mm') : '-';
    },
    fileId(file) {
      return file.id_schedule_file;
    },
    fileKey(file) {
      return this.fileId(file) ?? `${file.name}|${file.created_at}`;
    },
    getScheduleFiles() {
      if (!this.scheduleId)
        return;

      http.get(`/places/${this.place.id_place}/schedules/${this.scheduleId}/files`).then((response) => {
        this.files = response.data;
      });
    },
    onFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadForm.file = file;
        if (!this.uploadForm.fileName) {
          this.uploadForm.fileName = file.name.replace(/\.[^/.]+$/, "");
        }
      }
    },
    uploadFile() {
      if (!this.uploadForm.file || !this.uploadForm.fileName) {
        Alert.toastError('Selecione um arquivo e informe o nome');
        return;
      }

      this.uploading = true;

      const formData = new FormData();
      formData.append('files[0][name]', this.uploadForm.fileName);
      formData.append('files[0][file]', this.uploadForm.file);
      formData.append('id_sched', this.scheduleId);

      http.post(`/places/${this.place.id_place}/schedules/${this.scheduleId}/files`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {
        Alert.toastSuccess('Arquivo enviado com sucesso!');
        this.resetUploadForm();
        this.getScheduleFiles();
      }).catch((e) => {
        Alert.toastError(e.response?.data ?? e.response ?? 'Falha ao enviar arquivo');
      }).finally(() => {
        this.uploading = false;
      });
    },
    resetUploadForm() {
      this.uploadForm.fileName = '';
      this.uploadForm.file = null;
      this.$refs.fileInput.value = '';
    },
    downloadFile(file) {
      const fileUrl = file.file;
      
      if (fileUrl) {
        window.open(fileUrl, '_blank');
      } else {
        Alert.toastError('URL do arquivo não encontrada');
      }
    },
    deleteFile(file) {
      const id = this.fileId(file);
      if (!id) return;

      Swal.fire({
        title: 'Confirma apagar?',
        text: 'Essa ação não poderá ser desfeita.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sim, apagar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (!result.isConfirmed) return;

        http.delete(`/places/${this.place.id_place}/schedules/${this.scheduleId}/files/${id}`).then(() => {
          Alert.toastSuccess('Arquivo apagado com sucesso.');
          this.getScheduleFiles();
        }).catch((e) => {
          Alert.toastError(e.response?.data ?? e.response ?? 'Falha ao apagar arquivo');
        });
      });
    },
  }
}
</script>

<style scoped>

</style>


